import React from "react";

import { useMiddleware } from "@piqnt/runtime-core/react/ReactMount";
import { SpaceContext } from "../space";

import {
  findPlainBody,
  findPlainFixture,
  findPlainJoint,
} from "@piqnt/runtime-space/drawing-model";

import { BodyView } from "./BodyView";
import { JointView } from "./JointView";
import { FixtureView } from "./FixtureView";
import { SceneEdit } from "./SceneView";

export const SelectionView: React.FC = () => {
  const { context } = useMiddleware<SpaceContext>();
  const scene = context.draftScene.value;

  const multiselect = context.multiselect.value;

  if (multiselect.selected.length > 0) {
    return multiselect.selected.map((selection) => {
      if (selection?.type === "fixture") {
        if (selection.up?.type === "body") {
          const fixture = findPlainFixture(scene.world, selection.key);
          const body = findPlainBody(scene.world, selection.up.key);
          return <BodyView body={body} fixture={fixture} />;
        } else {
          const fixture = findPlainFixture(scene.world, selection.key);
          return <FixtureView fixture={fixture} />;
        }
      }

      if (selection?.type === "body") {
        const body = findPlainBody(scene.world, selection.key);
        return <BodyView body={body} />;
      }

      if (selection?.type === "joint") {
        const joint = findPlainJoint(scene.world, selection.key);
        return <JointView joint={joint} />;
      }
    });
  }

  return <SceneEdit />;
};
